import { render, staticRenderFns } from "./HeaderJourney.vue?vue&type=template&id=5650bfaa&scoped=true"
import script from "./HeaderJourney.vue?vue&type=script&lang=js"
export * from "./HeaderJourney.vue?vue&type=script&lang=js"
import style0 from "./HeaderJourney.vue?vue&type=style&index=0&id=5650bfaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650bfaa",
  null
  
)

export default component.exports